<template>
  <div class="px-5 pt-5 mb-6 border-b border-ricoma-gray-300">
    <ul class="flex items-center">
      <li
        v-for="(tab, index) in tabs"
        :key="`tab-${index}`"
        class="tab"
        :class="[tab.order === activateTab.order && 'selected']"
        @click="handleTab(tab)"
      >
        {{ tab.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      activateTab: {},
    };
  },
  watch: {
    activateTab(tab) {
      this.$emit('change', tab);
    },
  },
  methods: {
    handleTab(tab) {
      this.activateTab = tab;
    },
  },
  created() {
    this.activateTab = this.tabs[0];
  },
};
</script>

<style lang="postcss">
.tab {
  @apply border border-b-0 border-transparent rounded-t relative;
  @apply z-50 px-6 py-3 text-sm cursor-pointer;
  border-top: 4px solid transparent;
}
.tab.selected {
  @apply border border-b-0 border-ricoma-gray-300 rounded-t font-semibold;
  border-top: 4px solid orange;

  &::before {
    content: '';
    @apply block h-full bg-white absolute bottom-0 left-0 w-full -mb-1;
    z-index: -1;
  }
}
</style>
